"use client";

import { motion, useReducedMotion } from "framer-motion";

export default function GradientMesh() {
  const shouldReduceMotion = useReducedMotion();

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      <motion.div
        className="absolute top-[30%] left-[20%] w-[500px] h-[500px] rounded-full"
        style={{
          background: "radial-gradient(circle, hsl(45 100% 58% / 0.07), transparent 60%)",
        }}
        animate={shouldReduceMotion ? {} : {
          scale: [1, 1.15, 1],
          x: [0, 30, 0],
          y: [0, -20, 0],
        }}
        transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute top-[50%] right-[10%] w-[400px] h-[400px] rounded-full"
        style={{
          background: "radial-gradient(circle, hsl(35 80% 50% / 0.04), transparent 60%)",
        }}
        animate={shouldReduceMotion ? {} : {
          scale: [1, 1.1, 1],
          x: [0, -20, 0],
          y: [0, 15, 0],
        }}
        transition={{ duration: 16, repeat: Infinity, ease: "easeInOut", delay: 2 }}
      />
      <motion.div
        className="absolute top-[10%] right-[30%] w-[300px] h-[300px] rounded-full"
        style={{
          background: "radial-gradient(circle, hsl(45 100% 58% / 0.03), transparent 60%)",
        }}
        animate={shouldReduceMotion ? {} : {
          scale: [1, 1.2, 1],
          x: [0, -15, 0],
          y: [0, 25, 0],
        }}
        transition={{ duration: 20, repeat: Infinity, ease: "easeInOut", delay: 5 }}
      />
      <div
        className="absolute top-0 left-0 right-0 h-px"
        style={{ background: "linear-gradient(90deg, transparent, hsl(45 100% 58% / 0.08), transparent)" }}
      />
    </div>
  );
}
